import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../styles/campaignschedulerform.css";
import { toast } from "react-toastify";
import { handleApiError } from "../utils/errorHandler";

import Select, { components } from "react-select";
import { useMemo } from "react";

const predefinedOptions = ["{{name}}", "{{email}}", "{{whatsappMobile}}"];

const CampaignScheduleForm = () => {
  const templateCacheRef = useRef({});

  const [templateSearch, setTemplateSearch] = useState("");
  const searchDebounceRef = useRef(null);

  const [dropdownOpen, setDropdownOpen] = useState(null);
  const inputRefs = useRef({});
  const [campaignError, setCampaignError] = useState("");
  const [headerVariableErrors, setHeaderVariableErrors] = useState({});

  const navigate = useNavigate();

  const [campaignDetails, setCampaignDetails] = useState("");
  const [campaignName, setCampaignName] = useState("");
  const [campaignType, setCampaignType] = useState(""); // State to track audience selection

  const [scheduleDate, setScheduleDate] = useState(""); // State to track schedule date
  const [audience, setAudience] = useState(""); // State to track audience selection

  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // 'YYYY-MM-DD'
  });
  const [endDate, setEndDate] = useState(startDate);
  const [batchIds, setBatchIds] = useState([]);
  const [campaignBatchId, setCampaignBatchId] = useState("");
  const [audienceCount, setAudienceCount] = useState(0);
  const [batchData, setBatchData] = useState([]);

  const [selectedChannelId, setSelectedChannelId] = useState("");
  const [selectedChannelConnectionName, setSelectedChannelConnectionName] =
    useState("");
  const [channelSelected, setChannelSelected] = useState(false);
  const [channelList, setChannelList] = useState([]); // Track selected campaign detail option
  const [messageType, setMessageType] = useState("");
  const [selectedTemplateId, setSelectedTemplateId] = useState(""); // New state for selected template
  const [templateList, setTemplateList] = useState([]); // State to store template list
  const [templateTotal, setTemplateTotal] = useState(0);
  const [templatePage, setTemplatePage] = useState(1);
  const TEMPLATE_LIMIT = 20;
  const [templateMessage, setTemplateMessage] = useState(""); // State to store template message

  const [loading, setLoading] = useState(true); // State to track loading status

  const [selectedChannel, setSelectedChannel] = useState("");
  const [predefinedTemplate, setPredefinedTemplate] = useState("");

  const initialTemplateHeaders = {
    templateText: "",
    headerText: "",
    inputvariables: [],
    headervariables: [],
    buttonvariables: [],
    headerFormat: "",
    buttons: [],
  };

  console.log("New TEmplate List: ", templateList);

  const [templateHeadersList, setTemplateHeadersList] = useState(
    initialTemplateHeaders
  );

  const [templateVariables, setTemplateVariables] = useState({});
  const [templateButtonVariables, setTemplateButtonVariables] = useState({});
  const [templateHeaderVariables, setTemplateHeaderVariables] = useState({});
  const [templateHeaderImage, setTemplateHeaderImage] = useState("");
  const [templateHeaderVideo, setTemplateHeaderVideo] = useState("");
  const [templateHeaderDocument, setTemplateHeaderDocument] = useState("");

  // const options = templateList.map((template) => ({
  //   value: template.id,
  //   label: `${template.name} - 🟢${template.status} - 🟠${template.category}`,
  // }));

  const options = useMemo(() => {
    return templateList.map((template) => ({
      value: template.id,
      label: `${template.name} - 🟢${template.status} - 🟠${template.category}`,
    }));
  }, [templateList]);

  const optionsChannels = channelList.map((channel) => ({
    value: JSON.stringify({
      id: channel._id,
      name: channel.connectionname,
    }),
    label: channel.connectionname,
  }));

  const getUpdatedTemplateText = () => {
    // Replace placeholders in templateText with corresponding values from templateVariables
    let updatedText = templateHeadersList.templateText;
    templateHeadersList.inputvariables.forEach((variable, index) => {
      const placeholder = new RegExp(`\\{\\{${index + 1}\\}\\}`, "g"); // Match {{1}}, {{2}}, etc.
      updatedText = updatedText.replace(
        placeholder,
        templateVariables[index] || variable
      ); // Replace with input value or leave placeholder
    });
    return updatedText;
  };

  const getUpdatedTemplateButton = () => {
    if (!templateHeadersList || !Array.isArray(templateHeadersList.buttons)) {
      console.error(
        "Error: templateHeadersList.buttons is undefined or not an array."
      );
      return [];
    }

    let updatedButtons = templateHeadersList.buttons.map(
      (button, buttonIndex) => {
        let updatedButton = { ...button };

        if (
          updatedButton.url &&
          Array.isArray(templateHeadersList.buttonvariables)
        ) {
          // Each button gets its index-mapped value from templateButtonVariables
          const variable = templateHeadersList.buttonvariables[buttonIndex]; // Get the corresponding placeholder
          if (variable) {
            const replacementValue = templateButtonVariables[buttonIndex] ?? ""; // Map to templateButtonVariables index

            updatedButton.url = updatedButton.url.replace(
              variable,
              replacementValue
            );
          }
        }

        return updatedButton;
      }
    );

    return updatedButtons;
  };

  const getUpdatedHeaderText = () => {
    let updatedHeaderText = templateHeadersList.headerText;

    templateHeadersList.headervariables.forEach((variable, index) => {
      const placeholder = new RegExp(`\\{\\{${index + 1}\\}\\}`, "g"); // Match {{1}}, {{2}}, etc.
      updatedHeaderText = updatedHeaderText.replace(
        placeholder,
        templateHeaderVariables[index] || variable
      ); // Replace with input value or leave placeholder
    });
    return updatedHeaderText;
  };

  const getUpdatedHeaderImage = () => {
    let updatedHeaderImage = templateHeadersList.headerImageUrl;

    // Directly replace headerImageUrl with user input from templateHeaderImage
    if (templateHeaderImage) {
      updatedHeaderImage = templateHeaderImage;
    }

    return updatedHeaderImage;
  };

  const getUpdatedHeaderVideo = () => {
    let updatedHeaderVideo = templateHeadersList.headerVideoUrl;
    // Directly replace headerImageUrl with user input from templateHeaderVideo
    if (templateHeaderVideo) {
      updatedHeaderVideo = templateHeaderVideo;
    }
    return updatedHeaderVideo;
  };

  const getUpdatedHeaderDocument = () => {
    let updatedHeaderDocument = templateHeadersList.headerPdfUrl;
    // Directly replace headerImageUrl with user input from templateHeaderDocument
    if (templateHeaderDocument) {
      updatedHeaderDocument = templateHeaderDocument;
    }

    return updatedHeaderDocument;
  };

  const updatedTemplateText = getUpdatedTemplateText();
  const updatedTemplateButton = getUpdatedTemplateButton();
  const updatedHeaderText = getUpdatedHeaderText();
  const updatedHeaderImage = getUpdatedHeaderImage();
  const updatedHeaderVideo = getUpdatedHeaderVideo();
  const updatedHeaderDocument = getUpdatedHeaderDocument();

  useEffect(() => {
    if (campaignDetails === "WA Cloud") {
      fetchChannelData();
    } else if (campaignDetails === "WA Team") {
      fetchChannelList();
    }
  }, [campaignDetails]);

  const fetchChannelData = async () => {
    try {
      const response = await axios.get("/api/campaignscheduler/getallchannel");
      setChannelList(response.data || []);
    } catch (error) {
      console.error("Failed to fetch channels:", error);
      handleApiError(error, "Failed to fetch channels:");
    }
  };

  // WA Team API
  const fetchChannelList = async () => {
    try {
      const response = await axios.get(
        "/api/campaignscheduler/getallchannellist"
      );
      setChannelList(response.data || []);
    } catch (error) {
      console.error("Failed to fetch channels:", error);
      handleApiError(error, "Failed to fetch channels");
    }
  };

  const [visibleOptions, setVisibleOptions] = useState(7);
  const loadingMoreRef = useRef(false);

  // const MenuList = (props) => {
  //   const { children } = props;

  //   // Normal options + See More button
  //   return (
  //     <components.MenuList {...props}>
  //       {children}
  //       {options.length > visibleOptions && (
  //         <div
  //           style={{
  //             padding: "8px",
  //             textAlign: "center",
  //             cursor: "pointer",
  //             color: "blue",
  //             fontWeight: "500",
  //           }}
  //           onClick={(e) => {
  //             e.stopPropagation(); // prevent selecting
  //             setVisibleOptions((prev) => prev + 7);
  //           }}
  //         >
  //           See More
  //         </div>
  //       )}
  //     </components.MenuList>
  //   );
  // };

  const menuScrollRef = useRef(0);

  const MenuList = (props) => {
    const { children, innerRef, innerProps } = props;

    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;

      // 🔐 scroll position save
      menuScrollRef.current = scrollTop;

      // bottom reached
      if (
        scrollTop + clientHeight >= scrollHeight - 10 &&
        templateList.length < templateTotal &&
        !loading
      ) {
        fetchTemplateListVersionTwo(templateSearch, templatePage + 1, true);
      }
    };

    return (
      <div
        ref={(node) => {
          // react-select internal ref
          innerRef(node);

          // 🔐 scroll restore after re-render
          if (node) {
            node.scrollTop = menuScrollRef.current;
          }
        }}
        {...innerProps}
        onScroll={handleScroll}
        style={{
          maxHeight: 300,
          overflowY: "auto",
        }}
      >
        {children}
      </div>
    );
  };

  const fetchTemplateList = async () => {
    if (!selectedChannelId || templateList.length > 0) return;

    setLoading(true);
    try {
      const response = await axios.get(
        `/api/campaignscheduler/${selectedChannelId}/getalltemplateapproved`
      );
      setTemplateList(response.data);
      console.log("Template List : ", response.data);
    } catch (error) {
      console.error("Failed to fetch templates:", error);
      // alert("Failed to fetch templates Cloud. Please try again later.");
      handleApiError(
        error,
        "Failed to fetch templates Cloud. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  // const fetchTemplateListVersionTwo = async () => {
  //   if (!selectedChannelId) return;

  //   setLoading(true);
  //   try {
  //     const response = await axios.get(
  //       `/api/campaignscheduler/${selectedChannelId}/getalltemplateapprovedversiontwo`
  //     );
  //     setTemplateList(response.data);
  //     console.log("Template List Version Two :", response.data);
  //   } catch (error) {
  //     console.error("Failed to fetch templates:", error);
  //     // alert("Failed to fetch templates V2. Please try again later.");
  //     handleApiError(
  //       error,
  //       "Failed to fetch templates V2. Please try again later."
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const fetchTemplateListVersionTwo = async (
  //   searchText = "",
  //   page = 1,
  //   append = false
  // ) => {
  //   if (!selectedChannelId || loadingMoreRef.current) return;

  //   loadingMoreRef.current = true;
  //   setLoading(true);

  //   try {
  //     const response = await axios.get(
  //       `/api/campaignscheduler/${selectedChannelId}/getalltemplateapprovedversiontwo`,
  //       {
  //         params: {
  //           search: searchText,
  //           page,
  //           limit: TEMPLATE_LIMIT,
  //         },
  //       }
  //     );

  //     const { data, total } = response.data;

  //     setTemplateTotal(total);
  //     setTemplatePage(page);

  //     setTemplateList((prev) => (append ? [...prev, ...data] : data));
  //   } catch (error) {
  //     handleApiError(error, "Failed to fetch templates V2");
  //   } finally {
  //     setLoading(false);
  //     loadingMoreRef.current = false;
  //   }
  // };

  const fetchTemplateListVersionTwo = async (
    searchText = "",
    page = 1,
    append = false
  ) => {
    if (!selectedChannelId || loadingMoreRef.current) return;

    const cacheKey = `${selectedChannelId}_${searchText}_${page}`;

    // 🔥 CACHE HIT
    if (templateCacheRef.current[cacheKey]) {
      const cached = templateCacheRef.current[cacheKey];
      setTemplateTotal(cached.total);
      setTemplatePage(page);
      setTemplateList((prev) =>
        append ? [...prev, ...cached.data] : cached.data
      );
      return;
    }

    loadingMoreRef.current = true;
    setLoading(true);

    try {
      const response = await axios.get(
        `/api/campaignscheduler/${selectedChannelId}/getalltemplateapprovedversiontwo`,
        {
          params: { search: searchText, page, limit: TEMPLATE_LIMIT },
        }
      );

      const { data, total } = response.data;

      // 🔥 SAVE CACHE
      templateCacheRef.current[cacheKey] = { data, total };

      setTemplateTotal(total);
      setTemplatePage(page);
      setTemplateList((prev) => (append ? [...prev, ...data] : data));
    } finally {
      setLoading(false);
      loadingMoreRef.current = false;
    }
  };

  useEffect(() => {
    if (selectedChannelId) {
      if (campaignDetails === "WA Cloud") {
        fetchTemplateList();
      } else if (campaignDetails === "WA Team") {
        fetchTemplateListVersionTwo();
      }
    }
  }, [selectedChannelId]);

  // const handleTemplateSearch = (inputValue) => {
  //   setTemplateSearch(inputValue);

  //   clearTimeout(searchDebounceRef.current);
  //   searchDebounceRef.current = setTimeout(() => {
  //     fetchTemplateListVersionTwo(inputValue, 1, false);
  //   }, 400);
  // };

  const handleTemplateSearch = (inputValue) => {
    setTemplateSearch(inputValue);

    if (inputValue.length < 2) return; // 🔥 MIN 2 CHAR SEARCH

    clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      fetchTemplateListVersionTwo(inputValue, 1, false);
    }, 300); // 🔥 faster debounce
  };

  const [predefinedTemplates, setPredefinedTemplates] = useState([]);

  const predefinedTemplateOptions = predefinedTemplates.map((template) => ({
    value: template._id,
    label: template.templatename,
  }));

  useEffect(() => {
    const fetchPredefinedTemplates = async () => {
      try {
        const response = await axios.get("/api/predefinedtemplate/getall");
        console.log(response);
        setPredefinedTemplates(response.data.data);
        console.log("Predefined Templates :", response.data.data);
      } catch (error) {
        console.error("Failed to fetch predefined templates:", error);
        handleApiError(error, "Failed to fetch predefined templates");
      }
    };

    fetchPredefinedTemplates();
  }, []);

  const handlePredefinedTemplateSelect = (templateId) => {
    if (!templateId) {
      setTemplateHeaderVariables({});
      setTemplateVariables({});
      setTemplateButtonVariables({});
      return;
    }

    const selectedTemplate = predefinedTemplates.find(
      (template) => template._id === templateId
    );

    if (selectedTemplate) {
      const values = selectedTemplate.predefinedtemplate || [];

      const headerVarCount = templateHeadersList.headervariables.length || 0;
      const bodyVarCount = templateHeadersList.inputvariables.length || 0;
      const buttonVarCount = templateHeadersList.buttonvariables?.length || 0;

      const headerVars = {};
      const bodyVars = {};
      const buttonVars = {};

      let index = 0;

      // Fill HEADER VARIABLES first
      for (let i = 0; i < headerVarCount; i++) {
        headerVars[i] = values[index] || "";
        index++;
      }

      // Fill BODY VARIABLES next
      for (let i = 0; i < bodyVarCount; i++) {
        bodyVars[i] = values[index] || "";
        index++;
      }

      // Fill BUTTON VARIABLES last
      for (let i = 0; i < buttonVarCount; i++) {
        buttonVars[i] = values[index] || "";
        index++;
      }

      setTemplateHeaderVariables(headerVars);
      setTemplateVariables(bodyVars);
      setTemplateButtonVariables(buttonVars);
    }
  };

  console.log("Predefined Templates :", predefinedTemplates);

  const handleCampaignDetailsChange = (event) => {
    setCampaignDetails(event.target.value);
    // Reset everything related to the old campaign
    setChannelList([]);
    setChannelSelected(false); // Reset channel selection
    setSelectedChannelId(""); // Reset selected channel
    setSelectedChannelConnectionName(""); // Reset selected channel connection name
    setTemplateList([]); // Clear template list
    setMessageType(""); // Reset message type
    setSelectedChannel("");
    setTemplateHeadersList(initialTemplateHeaders);
    setTemplateVariables({});
    setTemplateHeaderVariables({});
    setTemplateHeaderImage("");
    setTemplateHeaderVideo("");
    setTemplateHeaderDocument("");
    setPredefinedTemplate("");
  };

  const handleCampaignNameChange = (e) => {
    const value = e.target.value;
    setCampaignName(value);

    if (value.length > 0) {
      setCampaignError("Make sure, the Camapign Name should not be duplicate!");
    } else {
      setCampaignError("");
    }
  };

  const handleCampaignTypeChange = (event) => {
    setCampaignType(event.target.value); // Update audience state based on selection
  };

  const handleScheduleDateChange = (event) => {
    setScheduleDate(event.target.value); // Update audience state based on selection
  };

  // const handleAudienceChange = (event) => {
  //   setAudience(event.target.value); // Update audience state based on selection
  // };

  const handleAudienceChange = (event) => {
    const value = event.target.value;
    setAudience(value);

    if (value !== "Segmented") {
      setCampaignBatchId("");
      setBatchIds([]);
      setAudienceCount(0);
      setBatchData([]);
    } else {
      // 🔥 Segmented select hone pe batch fetch
      fetchBatchIds(startDate);
    }
  };

  // useEffect(() => {
  //   fetchBatchIds(startDate);
  // }, []);

  // const fetchBatchIds = async (date) => {
  //   try {
  //     const response = await axios.get(
  //       `/api/campaignscheduler/getfiltercampaign`,
  //       {
  //         params: { startDate: date, endDate: date },
  //       }
  //     );
  //     if (response.status === 200) {
  //       const batchList = response.data.contact;
  //       setBatchIds(batchList);
  //       const firstBatchId = batchList[0] || "";
  //       setCampaignBatchId(firstBatchId);

  //       if (firstBatchId) {
  //         fetchBatchDetails(firstBatchId);
  //       }
  //     } else {
  //       console.error("Failed to fetch batch IDs:", response.data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching batch IDs:", error);
  //     handleApiError(error, "Error fetching batch IDs");
  //   }
  // };

  const fetchBatchIds = async (date) => {
    try {
      const response = await axios.get(
        `/api/campaignscheduler/getfiltercampaign`,
        {
          params: { startDate: date, endDate: date },
        }
      );

      if (response.status === 200) {
        setBatchIds(response.data.contact || []);
        setCampaignBatchId(""); // 🔥 no auto select
        setAudienceCount(0);
        setBatchData([]);
      }
    } catch (error) {
      handleApiError(error, "Error fetching batch IDs");
    }
  };

  const handleDateChange = async (e) => {
    const date = e.target.value;
    setStartDate(date);
    setEndDate(date);

    if (date) {
      fetchBatchIds(date);
    }
  };

  const handleBatchChange = async (event) => {
    const campaignId = event.target.value;
    setCampaignBatchId(campaignId);

    if (campaignId) {
      fetchBatchDetails(campaignId);
    }
  };

  const fetchBatchDetails = async (campaignId) => {
    try {
      const response = await axios.get(
        `/api/campaignscheduler/getcampaign/${campaignId}`
      );
      if (response.status === 200) {
        setAudienceCount(response.data.length);
        setBatchData(response.data);
      } else {
        console.error("Failed to fetch Audience");
      }
    } catch (error) {
      console.error("Error fetching batch details:", error);
      handleApiError(error, "Error fetching batch details");
    }
  };

  const handleChannelChange = (value) => {
    const selected = JSON.parse(value);
    setSelectedChannel(value);
    setSelectedChannelId(selected.id);
    setChannelSelected(!!selected.id);
    setSelectedChannelConnectionName(selected.name);

    // 🔹 Reset all dependent states
    setMessageType("");
    setTemplateHeadersList(initialTemplateHeaders);
    setPredefinedTemplate("");
    setTemplateVariables([]);
    setTemplateHeaderVariables([]);
    setTemplateHeaderImage("");
    setTemplateHeaderVideo("");
    setTemplateHeaderDocument("");
    setDropdownOpen(null);
    setTemplateList([]);
    setSelectedTemplateId("");
  };

  const handleMessageTypeChange = (event) => {
    setMessageType(event.target.value); // Update state based on selected message type
    setTemplateHeadersList(initialTemplateHeaders);
  };

  const handleTemplateHeadersChange = (event) => {
    const templateId = event.target.value;
    setSelectedTemplateId(templateId); // Update selected template ID
  };

  const handleHeaderVariableChange = (index, value) => {
    if (value.length <= 60) {
      // Update variable only if <= 60 chars
      setTemplateHeaderVariables((prev) => ({
        ...prev,
        [index]: value,
      }));

      // Clear error if valid
      setHeaderVariableErrors((prev) => ({
        ...prev,
        [index]: "",
      }));
    } else {
      // Set error if exceeding limit
      setHeaderVariableErrors((prev) => ({
        ...prev,
        [index]: "You are exceeding the text limit (max 60 characters).",
      }));
    }
  };

  const handleHeaderImageChange = (event) => {
    setTemplateHeaderImage(event.target.value);
  };

  const handleHeaderVideoChange = (event) => {
    setTemplateHeaderVideo(event.target.value);
  };

  const handleHeaderDocumentChange = (event) => {
    setTemplateHeaderDocument(event.target.value);
  };

  const handleInsertVariableChange = (index, value) => {
    // Update the specific variable in the state
    setTemplateVariables((prev) => ({
      ...prev,
      [index]: value,
    }));
  };

  const handleInsertText = (index, text) => {
    const input = inputRefs.current[index];
    if (!input) return;

    const cursorPos = input.selectionStart;

    const value = templateVariables[index] || "";

    // Insert selected text at cursor position
    const newValue =
      value.substring(0, cursorPos) + text + value.substring(cursorPos);

    setTemplateVariables((prev) => ({ ...prev, [index]: newValue }));

    // Restore cursor position
    setTimeout(() => {
      input.selectionStart = input.selectionEnd = cursorPos + text.length;
      input.focus();
    }, 0);

    setDropdownOpen(null); // Close dropdown after selection
  };

  const handleButtonVariableChange = (index, value) => {
    // Update the specific variable in the state
    setTemplateButtonVariables((prev) => ({
      ...prev,
      [index]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      campaignDetails,
      campaignName,
      campaignType,
      scheduleDate: campaignType === "Immediate" ? "" : scheduleDate,
      audience,
      startDate,
      campaignBatchId,
      batchData,
      channelSelected,
      selectedChannelId,
      selectedChannelConnectionName,
      messageType,
      templateVariables,
      templateButtonVariables,
      templateMessage,
      updatedTemplateText: updatedTemplateText,
      updatedTemplateButton: updatedTemplateButton,
      updatedHeaderText: updatedHeaderText,
      updatedHeaderImage: updatedHeaderImage,
      updatedHeaderVideo: updatedHeaderVideo,
      updatedHeaderDocument: updatedHeaderDocument,
      templateHeadersList,
    };

    try {
      const response = await axios.post(
        "/api/campaignscheduler/add_campaign_scheduler",
        formData
      );

      if (response.status === 201 || response.status === 200) {
        // Store notification state in sessionStorage before redirecting
        sessionStorage.setItem(
          "campaign_success",
          "Campaign created successfully!"
        );

        // Clear form fields
        setCampaignDetails("");
        setCampaignName("");
        setCampaignType("");
        setScheduleDate("");
        setAudience("");
        setStartDate(new Date().toISOString().split("T")[0]);
        setCampaignBatchId("");
        setBatchData([]);
        setChannelSelected(false);
        setSelectedChannelId("");
        setSelectedChannelConnectionName("");
        setMessageType("");
        setTemplateVariables({});

        // Redirect to the campaign scheduler
        navigate(-1);
      }
    } catch (error) {
      console.error("Error submitting the form: ", error);
      // toast.error("Failed to create campaign. Try again!");
      handleApiError(error, "FFailed to create campaign.");
    }
  };

  useEffect(() => {
    const fetchTemplateHeaders = async () => {
      if (!selectedTemplateId || !selectedChannelId) return; // Only fetch if both are selected
      console.log(selectedTemplateId);
      try {
        const response = await axios.get(
          `/api/campaignscheduler/${selectedChannelId}/gettemplate/${selectedTemplateId}`
        );
        setTemplateHeadersList(response.data || []);
      } catch (error) {
        console.error("Failed to fetch template headers:", error);
        handleApiError(error, "Failed to fetch template headers");
      }
    };

    fetchTemplateHeaders();
  }, [selectedChannelId, selectedTemplateId]); // Add dependencies

  return (
    <div className="page-content w-100">
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <h4 className="mb-0">Campaign Scheduler Form</h4>
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => navigate(-1)}
              >
                &larr; Back
              </button>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-12">
            <div className="card shadow-sm">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="d-flex gap-3 flex-column">
                    <div
                      className="d-flex gap-2"
                      style={{
                        padding: "10px 15px",
                      }}
                    >
                      {/* Campaign Details */}
                      <div
                        className="mx-auto"
                        style={{
                          padding: "10px 15px",
                          width: "33.33%",
                        }}
                      >
                        <div className="mb-2">
                          <label className="form-label fw-bold">
                            Campaign Details:
                          </label>
                          <div className="d-flex gap-3 mt-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="campaignDetailsOptions"
                                id="campaignDetails1"
                                value="WA Cloud"
                                onChange={handleCampaignDetailsChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="campaignDetails1"
                              >
                                WA Cloud
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="campaignDetailsOptions"
                                id="campaignDetails2"
                                value="WA Team"
                                onChange={handleCampaignDetailsChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="campaignDetails2"
                              >
                                WA Team
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Campaing Name */}
                      <div
                        className="mx-auto"
                        style={{
                          padding: "10px 15px",
                          width: "33.33%",
                        }}
                      >
                        <div className="mb-2">
                          <label
                            className="form-label fw-bold"
                            htmlFor="campaignName"
                          >
                            Campaign Name:
                          </label>
                          <input
                            type="text"
                            id="campaignName"
                            className="form-control"
                            placeholder="Enter Campaign Name"
                            value={campaignName}
                            onChange={handleCampaignNameChange}
                          />
                          {campaignError && (
                            <small className="text-success">
                              {campaignError}
                            </small>
                          )}
                        </div>
                      </div>
                      {/* Campaign Type */}
                      <div
                        className="mx-auto"
                        style={{
                          padding: "10px 15px",
                          width: "33.33%",
                        }}
                      >
                        <div className="mb-2">
                          <label className="form-label fw-bold">
                            Campaign Type:
                          </label>
                          <div>
                            <div className="d-flex gap-3 mt-2">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="campaignTypeOptions"
                                  id="campaignType1"
                                  value="Immediate"
                                  onChange={handleCampaignTypeChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="campaignType1"
                                >
                                  Immediate
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="campaignTypeOptions"
                                  id="campaignType2"
                                  value="Schedule"
                                  onChange={handleCampaignTypeChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="campaignType2"
                                >
                                  Schedule
                                </label>
                              </div>
                            </div>

                            {campaignType === "Schedule" && (
                              <div className="mt-2">
                                <label
                                  htmlFor="dateTimeSelect"
                                  className="form-label"
                                >
                                  Schedule Date & Time:
                                </label>
                                <input
                                  type="datetime-local"
                                  className="form-control"
                                  id="dateTimeSelect"
                                  value={scheduleDate}
                                  onChange={handleScheduleDateChange}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="d-flex gap-2"
                      style={{
                        padding: "10px 15px",
                      }}
                    >
                      <div
                        className="mx-auto"
                        style={{
                          width: "40%",
                          padding: "10px 15px",
                        }}
                      >
                        <div className="mb-2">
                          <div>
                            <label className="form-label fw-bold">
                              Audience: {audienceCount}
                            </label>
                          </div>
                          <div>
                            <div className="d-flex gap-3 mt-1">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="AudienceOptions"
                                  id="Audience1"
                                  value="All Contacts"
                                  onChange={handleAudienceChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="Audience1"
                                >
                                  All Contacts from CRM
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="AudienceOptions"
                                  id="Audience2"
                                  value="Segmented"
                                  onChange={handleAudienceChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="Audience2"
                                >
                                  Segmented
                                </label>
                              </div>
                            </div>

                            {audience === "Segmented" && (
                              <div className="d-flex gap-3 mt-3">
                                <div className="mt-3">
                                  <label
                                    htmlFor="dateSelect"
                                    className="form-label"
                                  >
                                    Campaign Date:
                                  </label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    id="dateSelect"
                                    value={startDate}
                                    onChange={handleDateChange}
                                  />
                                </div>

                                <div className="mt-3">
                                  <label
                                    htmlFor="batchSelect"
                                    className="form-label"
                                  >
                                    Campaign Batch ID:
                                  </label>
                                  {/* <select
                                    id="batchSelect"
                                    className="form-select"
                                    value={campaignBatchId}
                                    onChange={handleBatchChange}
                                    disabled={!batchIds.length}
                                  >
                                    <option value="" disabled>
                                      {batchIds.length
                                        ? "Select an option"
                                        : "No batch IDs available"}
                                    </option>
                                    {batchIds.map((id) => (
                                      <option key={id} value={id}>
                                        {id}
                                      </option>
                                    ))}
                                  </select> */}
                                  <select
                                    id="batchSelect"
                                    className="form-select"
                                    value={campaignBatchId}
                                    onChange={handleBatchChange}
                                    disabled={audience !== "Segmented"}
                                  >
                                    <option value="" disabled>
                                      Select Campaign Batch ID
                                    </option>

                                    {batchIds.map((id) => (
                                      <option key={id} value={id}>
                                        {id}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className="mx-auto"
                        style={{
                          width: "60%",
                          padding: "10px 15px",
                        }}
                      >
                        <div className="mb-2">
                          <div>
                            <label className="form-label fw-bold">
                              Template:
                            </label>
                          </div>
                          <div>
                            <div className="d-flex gap-5 align-items-center">
                              <label
                                htmlFor="channelSelect"
                                className="form-label"
                              >
                                Channel:
                              </label>

                              <Select
                                options={optionsChannels}
                                isDisabled={
                                  !(
                                    campaignDetails === "WA Cloud" ||
                                    campaignDetails === "WA Team"
                                  )
                                }
                                onChange={(selected) =>
                                  handleChannelChange(selected.value)
                                }
                                value={optionsChannels.find(
                                  (opt) => opt.value === selectedChannel
                                )}
                                placeholder="Select a channel"
                                className="w-100"
                              />
                            </div>

                            {channelSelected && (
                              <div className="mt-3">
                                <label
                                  htmlFor="channelSelect"
                                  className="form-label"
                                >
                                  Message Type:
                                </label>
                                <div className="d-flex gap-5 mt-2">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="TemplateOptions"
                                      id="template1"
                                      value="Pre-Approved"
                                      checked={messageType === "Pre-Approved"}
                                      onChange={handleMessageTypeChange}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="template1"
                                    >
                                      Pre-Approved Template
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="TemplateOptions"
                                      id="template2"
                                      value="Regular Message"
                                      checked={
                                        messageType === "Regular Message"
                                      }
                                      onChange={handleMessageTypeChange}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="template2"
                                    >
                                      Regular Message
                                    </label>
                                  </div>
                                </div>
                              </div>
                            )}

                            {messageType === "Pre-Approved" && (
                              <div className="mt-3">
                                <label
                                  htmlFor="templateSelect"
                                  className="form-label"
                                >
                                  Template:
                                </label>
                                {/* <Select
                                  inputId="templateSelect"
                                  // options={options}
                                  options={options.slice(0, visibleOptions)}
                                  components={{ MenuList }}
                                  onChange={(selectedOption) =>
                                    handleTemplateHeadersChange({
                                      target: { value: selectedOption.value },
                                    })
                                  }
                                  placeholder="Select a template..."
                                  isSearchable
                                  isLoading={templateList.length === 0}
                                /> */}
                                {/* <Select
                                  options={options.slice(0, visibleOptions)}
                                  components={{ MenuList }}
                                  isSearchable
                                  placeholder="Select a template..."
                                  onMenuOpen={() => {
                                    setVisibleOptions(10);
                                    menuScrollRef.current = 0; // 🔥 reset only on open
                                  }}
                                  onChange={(selectedOption) =>
                                    handleTemplateHeadersChange({
                                      target: { value: selectedOption.value },
                                    })
                                  }
                                /> */}

                                {/* <Select
                                  options={options.slice(0, visibleOptions)}
                                  components={{ MenuList }}
                                  isSearchable
                                  placeholder="Search template..."
                                  isLoading={loading}
                                  onInputChange={handleTemplateSearch} // 🔥 BACKEND SEARCH
                                  onMenuOpen={() => {
                                    setVisibleOptions(10);
                                    menuScrollRef.current = 0;
                                    fetchTemplateListVersionTwo(
                                      templateSearch,
                                      false
                                    );
                                  }}
                                  onChange={(selectedOption) =>
                                    handleTemplateHeadersChange({
                                      target: { value: selectedOption.value },
                                    })
                                  }
                                /> */}
                                <Select
                                  menuShouldScrollIntoView={false}
                                  blurInputOnSelect
                                  options={options}
                                  components={{ MenuList }}
                                  isSearchable
                                  placeholder="Search template..."
                                  isLoading={loading}
                                  onInputChange={handleTemplateSearch}
                                  onMenuOpen={() =>
                                    fetchTemplateListVersionTwo(
                                      templateSearch,
                                      1,
                                      false
                                    )
                                  }
                                  onChange={(selectedOption) =>
                                    handleTemplateHeadersChange({
                                      target: { value: selectedOption.value },
                                    })
                                  }
                                />
                              </div>
                            )}

                            {/* Dynamic Input Boxes */}
                            {templateHeadersList.inputvariables &&
                              templateHeadersList.inputvariables.length > 0 && (
                                <div className="d-flex gap-3 mt-4">
                                  <div
                                    className="input_variables"
                                    style={{
                                      maxWidth: "40%",
                                    }}
                                  >
                                    <Select
                                      options={predefinedTemplateOptions}
                                      placeholder="Select pre-template"
                                      className="mb-3"
                                      isClearable
                                      onChange={(selected) => {
                                        if (selected) {
                                          setPredefinedTemplate(selected.value);
                                          handlePredefinedTemplateSelect(
                                            selected.value
                                          );
                                        } else {
                                          setPredefinedTemplate("");
                                          handlePredefinedTemplateSelect("");
                                        }
                                      }}
                                      value={
                                        predefinedTemplateOptions.find(
                                          (opt) =>
                                            opt.value === predefinedTemplate
                                        ) || null
                                      }
                                    />

                                    {/* HEADER INPUTS BASED ON headerFormat */}
                                    {templateHeadersList.headerFormat ===
                                      "TEXT" &&
                                      templateHeadersList.headervariables.map(
                                        (variable, index) => (
                                          <div className="mb-3" key={index}>
                                            <label
                                              htmlFor={`templateVariable-${index}`}
                                              className="form-label"
                                            >
                                              {`HEADER VARIABLE #${index + 1}`}
                                            </label>
                                            <input
                                              type="text"
                                              id={`templateVariable-${index}`}
                                              className="form-control"
                                              placeholder={`Enter value for ${variable}`}
                                              value={
                                                templateHeaderVariables[
                                                  index
                                                ] || ""
                                              }
                                              onChange={(e) =>
                                                handleHeaderVariableChange(
                                                  index,
                                                  e.target.value
                                                )
                                              }
                                            />
                                            {headerVariableErrors[index] && (
                                              <small className="text-danger">
                                                {headerVariableErrors[index]}
                                              </small>
                                            )}
                                          </div>
                                        )
                                      )}

                                    {templateHeadersList.headerFormat ===
                                      "IMAGE" && (
                                      <div className="mb-3">
                                        <label
                                          htmlFor="headerImageUpload"
                                          className="form-label"
                                        >
                                          HEADER IMAGE:
                                        </label>
                                        <input
                                          type="text"
                                          id="headerImageUpload"
                                          className="form-control"
                                          placeholder="Enter image URL"
                                          value={templateHeaderImage || ""}
                                          onChange={handleHeaderImageChange}
                                        />
                                      </div>
                                    )}

                                    {templateHeadersList.headerFormat ===
                                      "VIDEO" && (
                                      <div className="mb-3">
                                        <label
                                          htmlFor="headerVideoUpload"
                                          className="form-label"
                                        >
                                          HEADER VIDEO:
                                        </label>
                                        <input
                                          type="text"
                                          id="headerVideoUpload"
                                          className="form-control"
                                          placeholder="Enter video URL"
                                          value={templateHeaderVideo || ""}
                                          onChange={handleHeaderVideoChange}
                                        />
                                      </div>
                                    )}

                                    {templateHeadersList.headerFormat ===
                                      "DOCUMENT" && (
                                      <div className="mb-3">
                                        <label
                                          htmlFor="headerDocumentUpload"
                                          className="form-label"
                                        >
                                          HEADER DOCUMENT:
                                        </label>
                                        <input
                                          type="text"
                                          id="headerDocumentUpload"
                                          className="form-control"
                                          placeholder="Enter document URL"
                                          value={templateHeaderDocument || ""}
                                          onChange={handleHeaderDocumentChange}
                                        />
                                      </div>
                                    )}

                                    {/* BODY INPUT BOXES */}

                                    {templateHeadersList.inputvariables.map(
                                      (variable, index) => (
                                        <div
                                          className="mb-3 position-relative"
                                          key={index}
                                        >
                                          <label className="form-label">{`BODY VARIABLE #${
                                            index + 1
                                          }`}</label>
                                          <div className="input-container">
                                            {/* Input Field */}
                                            <input
                                              type="text"
                                              ref={(el) =>
                                                (inputRefs.current[index] = el)
                                              }
                                              className="form-control custom-input"
                                              placeholder={`Enter value for ${variable}`}
                                              value={
                                                templateVariables[index] || ""
                                              }
                                              onChange={(e) =>
                                                handleInsertVariableChange(
                                                  index,
                                                  e.target.value
                                                )
                                              }
                                            />

                                            {/* Dropdown Icon Inside Input Field */}
                                            <span
                                              className="custom-dropdown-icon"
                                              onClick={() =>
                                                setDropdownOpen(
                                                  dropdownOpen === index
                                                    ? null
                                                    : index
                                                )
                                              }
                                            >
                                              &lt;&gt;
                                            </span>

                                            {/* Dropdown Inside Input Field */}
                                            {dropdownOpen === index && (
                                              <div className="custom-dropdown">
                                                {predefinedOptions.map(
                                                  (option, idx) => (
                                                    <div
                                                      key={idx}
                                                      className="dropdown-item"
                                                      onClick={() =>
                                                        handleInsertText(
                                                          index,
                                                          option
                                                        )
                                                      }
                                                    >
                                                      {option}
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )
                                    )}

                                    <style>
                                      {`
                                        .input-container {
                                          position: relative;
                                          display: flex;
                                          align-items: center;
                                        }

                                        .custom-input {
                                          width: 100%;
                                          padding-right: 35px; /* Space for the dropdown icon */
                                        }

                                        .custom-dropdown-icon {
                                          position: absolute;
                                          right: 5px;
                                          bottom: 5px;
                                          cursor: pointer;
                                          font-size: 16px;
                                          
                                          padding: 3px 6px;
                                          
                                          user-select: none;
                                        }

                                        .custom-dropdown-icon:hover {
                                          font-weight: bold;
                                          
                                        }

                                        .custom-dropdown {
                                          position: absolute;
                                          bottom: -300%; /* Display below input field */
                                          right: 0px; /* Align to right inside input */
                                          background: white;
                                          border: 1px solid #ddd;
                                          border-radius: 4px;
                                          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
                                          width: 138px;
                                          z-index: 10;
                                        }

                                        .dropdown-item {
                                          padding: 8px;
                                          cursor: pointer;
                                          transition: background 0.2s;
                                        }

                                        .dropdown-item:hover {
                                          background: #f1f1f1;
                                        }
                                      `}
                                    </style>

                                    {/* BUTTON INPUT BOXES */}
                                    {templateHeadersList.buttonvariables.map(
                                      (variable, index) => (
                                        <div className="mb-3" key={index}>
                                          <label
                                            htmlFor={`templateVariable-${index}`}
                                            className="form-label"
                                          >
                                            {`BUTTON VARIABLE #${index + 1}`}
                                          </label>
                                          <input
                                            type="text"
                                            id={`templateVariable-${index}`}
                                            className="form-control"
                                            placeholder={`Enter value for ${variable}`}
                                            onChange={(e) =>
                                              handleButtonVariableChange(
                                                index,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                      )
                                    )}
                                  </div>

                                  <div
                                    className="template_preview"
                                    style={{ maxWidth: "60%" }}
                                  >
                                    <label
                                      htmlFor="templateBodyVariable1"
                                      className="form-label"
                                    >
                                      Template View :
                                    </label>
                                    <div className="whatsapp-modal-content">
                                      <div className="border p-2">
                                        <div className="message_template">
                                          {templateHeadersList.headerText && (
                                            <div className="header-text fw-bold">
                                              {getUpdatedHeaderText()}
                                            </div>
                                          )}

                                          {templateHeadersList.templateText && (
                                            <div
                                              className="whatsapp-message"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  getUpdatedTemplateText().replace(
                                                    /\n/g,
                                                    "<br>"
                                                  ),
                                              }}
                                            />
                                          )}
                                        </div>
                                        {templateHeadersList.buttons &&
                                          templateHeadersList.buttons.length >
                                            0 && (
                                            <div
                                              className={`d-flex gap-3 mt-2 mb-3 ${
                                                templateHeadersList.buttons
                                                  .length > 2
                                                  ? "flex-wrap"
                                                  : ""
                                              }`}
                                            >
                                              {templateHeadersList.buttons.map(
                                                (button, index) => (
                                                  <a
                                                    key={index}
                                                    href={button.url}
                                                    className="btn btn-success d-block mt-2 small_button"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                      flex:
                                                        templateHeadersList
                                                          .buttons.length > 2
                                                          ? "1 1 calc(50% - 1.5rem)"
                                                          : "unset",
                                                    }}
                                                  >
                                                    {button.text}
                                                  </a>
                                                )
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-end p-3">
                      <button type="submit" className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignScheduleForm;
